<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.customer' | translate }} #</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="crmId" class="ir-form-set" type="text" formControlName="CrmId" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.customer-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="Name" class="ir-form-set" type="text" formControlName="Name" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.address' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="Address" class="ir-form-set" type="text" formControlName="Address" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.city' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="City" class="ir-form-set" type="text" formControlName="City" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.country' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input type="hidden" name="Country" class="ir-form-set" formControlName="Country" />
                <div class="ir-line ir-select th-select" (click)="openCountriesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.Country.value
                        ? (editForm.controls.Country.value | country | async)
                        : ('plugins.installation-customer-info.select-country' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-customer-info.localEntity' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input type="hidden" name="LocalEntity" class="ir-form-set" formControlName="LocalEntity" />
                <div class="ir-line ir-select th-select" (click)="openLocalEntitiesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.LocalEntity.value
                        ? (editForm.controls.LocalEntity.value | localEntity)
                        : ('plugins.installation-customer-info.select-localEntity' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>
                <span>{{ 'plugins.installation-customer-info.languages' | translate }}</span>
              </h2>
            </td>
            <td>
              <div class="ir-form-group">
                <input type="hidden" name="Language" class="ir-form-set" formControlName="Language" />
                <div class="ir-line ir-select th-select" (click)="openLanguagesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.Language.value
                        ? (editForm.controls.Language.value | languages)
                        : ('plugins.installation-customer-info.select-language' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <ng-container>
            <tbody
              formArrayName="MachineSalesOrder"
              *ngFor="let item of machineSalesForm.controls; let i = index"
              class="optimisation-equipment"
            >
              <tr>
                <td class="margin-big"></td>
                <td class="th-plugin-line--remove" style="text-align: right">
                  <i class="material-icons" (click)="remove(i)">remove_circle</i>
                </td>
              </tr>

              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-customer-info.machine-sales-order' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <input name="MachineSalesOrder" class="ir-form-set" type="text" [formControlName]="i" />
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal (modalOutput)="selectLanguagesMenu($event)" (modalClosed)="onLanguagesMenuClose()" #languagesModal></modal>
<modal (modalOutput)="selectCountriesMenu($event)" (modalClosed)="onCountriesMenuClose($event)" #countriesModal></modal>
<modal
  (modalOutput)="selectLocalEntitiesMenu($event)"
  (modalClosed)="onLocalEntitiesMenuClose($event)"
  #localEntitiesModal
></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
